const chatMessages = document.getElementById("chatMessages");
const messageInput = document.getElementById("messageInput");
const sendBtn = document.getElementById("sendBtn");
const fabBtn = document.getElementById("fabBtn");
const chatCloseBtn = document.getElementById("chatCloseBtn");
const minimizeBtn = document.getElementById("minimizeBtn");
const closeBtn = document.getElementById("closeBtn");
const quickActionBtns = document.querySelectorAll(
  ".ai__chatbot-quick-action-btn"
);
// const liveAgentBtn = document.getElementById("liveAgentBtn");
const emailFieldContainer = document.getElementById("emailFieldContainer");
const emailInput = document.getElementById("emailInput");
const emailSubmitBtn = document.getElementById("emailSubmitBtn");
const emailValidation = document.getElementById("emailValidation");

const logoUploadArea = document.getElementById("logoUploadArea");
const logoFileInput = document.getElementById("logoFileInput");
const logoPreviewContainer = document.getElementById("logoPreviewContainer");
const logoPreviewList = document.getElementById("logoPreviewList");

const quoteModal = document.getElementById("quoteModal");
const quoteSummaryModal = document.getElementById("quoteSummaryModal");
const quoteForm = document.getElementById("quoteForm");
const closeQuoteModal = document.getElementById("closeQuoteModal");
const closeQuoteSummaryModal = document.getElementById(
  "closeQuoteSummaryModal"
);
// const cancelQuote = document.getElementById("cancelQuote");
const requestChanges = document.getElementById("requestChanges");
const closeSummary = document.getElementById("closeSummary");
const quoteSummaryContent = document.getElementById("quoteSummaryContent");

// New Code Start

// Get project name and route from window object (injected by template)
// Fallback to "quicksignage.com" if not set (for backward compatibility)
let PROJECT_NAME = (typeof window !== 'undefined' && window.PROJECT_NAME) 
  ? window.PROJECT_NAME 
  : "quicksignage.com";

let PROJECT_ROUTE = (typeof window !== 'undefined' && window.PROJECT_ROUTE) 
  ? window.PROJECT_ROUTE 
  : "quicksignage.com";

// Validate project name
if (!PROJECT_NAME || PROJECT_NAME === "") {
  console.error("⚠️ PROJECT_NAME is not set! Using default 'Quicksignage.com'");
  PROJECT_NAME = "Quicksignage.com";
  PROJECT_ROUTE = "quicksignage.com";
}

// Validate project route
if (!PROJECT_ROUTE || PROJECT_ROUTE === "") {
  console.error("⚠️ PROJECT_ROUTE is not set! Using default 'quicksignage.com'");
  PROJECT_ROUTE = "quicksignage.com";
}

// Create project-specific localStorage keys to prevent conflicts between different chatbots
const STORAGE_KEY_PREFIX = `chatbot_${PROJECT_ROUTE}_`;
const SESSION_ID_KEY = `${STORAGE_KEY_PREFIX}sessionId`;
const CHAT_USER_DATA_KEY = `${STORAGE_KEY_PREFIX}chat_user_data`;

// Project-specific color and name configuration
const PROJECT_CONFIG = {
  "signs.inc": {
    color: "#0188CC",
    name: "Signs Inc",
    icon: "/icon-logos/signs.jpg"
  },
  "signage.inc": {
    color: "#EA5B28",
    name: "Signage Inc",
    icon: "/icon-logos/signage.jpg"
  },
  "signmakerz.com": {
    color: "#EA5B28",
    name: "Signmakerz",
    icon: "/icon-logos/signmakerz.jpg"
  },
  "signmakers.net": {
    color: "#91A5A6",
    name: "Signmakers",
    icon: "/icon-logos/signmakes.net.jpg" // Note: filename has typo in folder (signmakes instead of signmakers)
  },
  "quicksignage.com": {
    color: "#2aada4",
    name: "QuickSignage",
    icon: "https://quicksignage.com/cdn/shop/files/quicksignage-white-green-transparent_220x.png?v=1720830496"
  },
  "signize.us": {
    color: "#B47C52",
    name: "Signize",
    icon: "/icon-logos/signize.webp"
  },
  "signage.com": {
    color: "#2464ED",
    name: "Signage",
    icon: "/icon-logos/signage.jpg"
  },
  "signs.store": {
    color: "#AEF037",
    name: "Signs Store",
    icon: "/icon-logos/signs.store.jpg"
  }
};

console.log("📋 Chatbot loaded for project:", PROJECT_NAME);

// New code End


const sessionId = generateSessionId();
let isTyping = false;
const _storedChatData = JSON.parse(localStorage.getItem(CHAT_USER_DATA_KEY) || '{}');
let userEmail = _storedChatData.email || "";
let emailCollected = !!userEmail;
let awaitingPhoneNumber = false;
let uploadedLogoURLs = "";

// socket
let socket = null;
let agentMode = false;
let agentRequestPending = false;
let customerTypingTimeout = null;
let isCustomerTyping = false;

const API_BASE_URL = "https://signize-chatbot.onrender.com";
const SOCKET_URL = "https://signize-chatbot.onrender.com";


document.addEventListener("DOMContentLoaded", () => {
  const chatContainer = document.querySelector(".ai__chatbot-chat-container");
  if (chatContainer) {
    chatContainer.classList.add("ai__chatbot-hidden");
  }

  if (fabBtn) {
    fabBtn.style.display = "flex";
  }

  initializeEventListeners();
  initializeSocket(); // socket
  focusInput();
  loadChatHistory();
});

function generateSessionId() {
  // Use project-specific localStorage key to prevent conflicts between different chatbots
  let genSessionId = localStorage.getItem(SESSION_ID_KEY);
  if (!genSessionId) {
    genSessionId =
      "session_" + Date.now() + "_" + Math.random().toString(36).substr(2, 9);
    localStorage.setItem(SESSION_ID_KEY, genSessionId);
  }
  return genSessionId;
}


function initializeEventListeners() {
  sendBtn.addEventListener("click", sendMessage);

  messageInput.addEventListener("keypress", (event) => {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      sendMessage();
    }
  });

  emailSubmitBtn.addEventListener("click", validateAndSubmitEmail);

  emailInput.addEventListener("input", validateEmailOnInput);
  emailInput.addEventListener("keypress", (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      validateAndSubmitEmail();
    }
  });

  if (logoUploadArea && logoFileInput) {
    logoUploadArea.addEventListener("click", () => logoFileInput.click());

    logoFileInput.addEventListener("change", chatbotHandleLogoFileSelect);

    logoUploadArea.addEventListener("dragover", chatbotHandleDragOver);
    logoUploadArea.addEventListener("dragleave", chatbotHandleDragLeave);
    logoUploadArea.addEventListener("drop", chatbotHandleDrop);
  }

  messageInput.addEventListener("focus", function () {
    this.parentElement.classList.add("focused");
  });

  messageInput.addEventListener("blur", function () {
    this.parentElement.classList.remove("focused");
  });

  quickActionBtns.forEach((btn) => {
    btn.addEventListener("click", function () {
      const action = this.dataset.action;
      handleQuickAction(action);
    });
  });

  // live agent
  // if (liveAgentBtn) {
  //   liveAgentBtn.addEventListener("click", requestLiveAgent);
  // }

  minimizeBtn.addEventListener("click", minimizeChat);
  closeBtn.addEventListener("click", closeChat);
  chatCloseBtn.addEventListener("click", closeChat);
  fabBtn.addEventListener("click", toggleChat);

  closeQuoteModal.addEventListener("click", closeQuoteForm);
  closeQuoteSummaryModal.addEventListener("click", closeQuoteSummary);
  // cancelQuote.addEventListener("click", closeQuoteForm);
  requestChanges.addEventListener("click", requestQuoteChanges);
  closeSummary.addEventListener("click", () => closeQuoteSummary(true));
  // Quote form submission - use button click instead of form submit
  const submitQuoteBtn = document.getElementById("submitQuoteBtn");
  if (submitQuoteBtn) {
    submitQuoteBtn.addEventListener("click", chatbotHandleQuoteSubmit);
  }

  const startFreshBtn = document.getElementById("startFreshBtn");
  if (startFreshBtn) {
    startFreshBtn.addEventListener("click", startFreshQuote);
  }

  quoteModal.addEventListener("click", (e) => {
    if (e.target === quoteModal) closeQuoteForm();
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      if (quoteModal.classList.contains("show")) {
        closeQuoteForm();
      }
      if (quoteSummaryModal.classList.contains("show")) {
        closeQuoteSummary();
      }
    }
  });

  const unitButtons = document.querySelectorAll(".ai__chatbot-unit-btn");
  unitButtons.forEach((btn) => {
    btn.addEventListener("click", function () {
      const field = this.dataset.field;
      const unit = this.dataset.unit;

      const fieldGroup = this.closest(".ai__chatbot-input-with-unit");
      fieldGroup
        .querySelectorAll(".ai__chatbot-unit-btn")
        .forEach((b) => b.classList.remove("active"));

      this.classList.add("active");

      const input = fieldGroup.querySelector("input");
      if (input) {
        input.dataset.unit = unit;
      }
    });
  });

  quoteSummaryModal.addEventListener("click", (e) => {
    if (e.target === quoteSummaryModal) closeQuoteSummary();
  });

  messageInput.addEventListener("input", autoResizeInput);

  // socket
  messageInput.addEventListener("input", function () {
    if (!socket || !socket.connected) {
      return;
    }

    if (customerTypingTimeout) {
      clearTimeout(customerTypingTimeout);
    }

    if (!isCustomerTyping) {
      isCustomerTyping = true;
      socket.emit("customer_typing", {
        session_id: sessionId,
        is_typing: true,
      });
    }

    customerTypingTimeout = setTimeout(() => {
      isCustomerTyping = false;
      if (socket && socket.connected) {
        socket.emit("customer_typing", {
          session_id: sessionId,
          is_typing: false,
        });
      }
    }, 2000);
  });

  // socket
  messageInput.addEventListener("keypress", function (event) {
    if (event.key === "Enter" && !event.shiftKey) {
      if (customerTypingTimeout) {
        clearTimeout(customerTypingTimeout);
        customerTypingTimeout = null;
      }
      if (isCustomerTyping && socket && socket.connected) {
        isCustomerTyping = false;
        socket.emit("customer_typing", {
          session_id: sessionId,
          is_typing: false,
        });
      }
    }
  });
}

// socket
function initializeSocket() {
  if (typeof io === "undefined") {
    return;
  }

  // socket
  socket = SOCKET_URL ? io(SOCKET_URL) : io();

  socket.on("connect", () => {
    socket.emit("join_session", { session_id: sessionId });
  });

  socket.on("disconnect", () => {});

  socket.on("reconnect", () => {
    socket.emit("join_session", { session_id: sessionId });
  });

  socket.on("session_joined", (data) => {});

  socket.on("agent_message", (data) => {
    if (!data || (data.session_id && data.session_id !== sessionId)) {
      return;
    }
    addMessage("agent", data.message, {
      agentName: "quicksignage.com" || data.agent_name || "Live Agent",
    });
    focusInput();
  });

  socket.on("agent_mode_started", (data) => {
    if (data && data.session_id === sessionId) {
      activateAgentMode(false);
    }
  });

  socket.on("agent_mode_ended", (data) => {
    if (data && data.session_id === sessionId) {
      deactivateAgentMode(false);
    }
  });

  socket.on("agent_typing", (data) => {
    if (data && data.session_id === sessionId) {
      showAgentTypingIndicator(data.is_typing);
    }
  });
}
// live agent
function activateAgentMode(showNotice = true) {
  if (agentMode) {
    return;
  }

  agentMode = true;

  // if (liveAgentBtn) {
  //   liveAgentBtn.classList.add("active");
  //   liveAgentBtn.disabled = false;
  //   liveAgentBtn.innerHTML = `
  //     <i class="fas fa-robot"></i>
  //     Back to AI Assistant
  //   `;
  // }

  if (showNotice) {
    addMessage(
      "system",
      "You are now connected with a live agent. Replies will appear here in real time."
    );
  }
}

// live agent
function deactivateAgentMode(showNotice = true) {
  if (!agentMode) {
    return;
  }

  agentMode = false;

  // if (liveAgentBtn) {
  //   liveAgentBtn.classList.remove("active");
  //   liveAgentBtn.disabled = false;
  //   liveAgentBtn.innerHTML = `
  //     <i class="fas fa-headset"></i>
  //     Talk to Live Agent
  //   `;
  // }

  if (showNotice) {
    addMessage(
      "ai",
      "You're now back with me, the AI assistant. I've kept your full conversation with the live agent as context so I can continue helping from here.\n\nWas that interaction with the live agent helpful, or is there anything else I can assist you with?"
    );
  }
}

// live agent
async function requestLiveAgent() {
  if (agentRequestPending) {
    return;
  }

  if (agentMode) {
    await endLiveAgent();
    return;
  }

  if (!userEmail) {
    showEmailField();
    showEmailValidation(
      "Please enter your email before requesting a live agent.",
      false
    );
    return;
  }

  agentRequestPending = true;
  // if (liveAgentBtn) {
  //   liveAgentBtn.classList.add("loading");
  // }

  try {
    const response = await fetch(`${API_BASE_URL}/live-agent`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        session_id: sessionId,
        email: userEmail,
      }),
    });

    const data = await response.json();

    if (response.ok && data.agent_active) {
      activateAgentMode();
    } else {
      addMessage(
        "system",
        data.message || "Unable to connect to a live agent at the moment."
      );
    }
  } catch (error) {
    addMessage(
      "system",
      "Unable to connect to a live agent right now. Please try again."
    );
  } finally {
    agentRequestPending = false;
    // if (liveAgentBtn) {
    //   liveAgentBtn.classList.remove("loading");
    // }
  }
}

// live agent
async function endLiveAgent() {
  if (agentRequestPending) return;

  if (!userEmail) {
    showEmailField();
    showEmailValidation(
      "Please enter your email to continue with the AI assistant.",
      false
    );
    return;
  }

  agentRequestPending = true;
  // if (liveAgentBtn) {
  //   liveAgentBtn.classList.add("loading");
  // }

  try {
    const response = await fetch(`${API_BASE_URL}/end-live-agent`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        session_id: sessionId,
        email: userEmail,
      }),
    });

    const data = await response.json();

    if (response.ok && data.conversation_flag === "bot") {
      deactivateAgentMode(true);
    } else {
      addMessage(
        "system",
        data.message ||
          "Unable to switch back to the AI assistant at the moment."
      );
    }
  } catch (error) {
    addMessage(
      "system",
      "Unable to switch back to the AI assistant right now. Please try again."
    );
  } finally {
    agentRequestPending = false;
    // if (liveAgentBtn) {
    //   liveAgentBtn.classList.remove("loading");
    // }
  }
}

const EMAIL_SUBMIT_BTN_HTML = emailSubmitBtn.innerHTML;

// Swap the submit button to a spinner while the email is checked server-side.
function setEmailSubmitLoading(isLoading) {
  emailSubmitBtn.classList.toggle("is-loading", isLoading);
  emailSubmitBtn.disabled = isLoading;
  emailSubmitBtn.setAttribute("aria-busy", isLoading ? "true" : "false");
  emailSubmitBtn.innerHTML = isLoading
    ? '<i class="fas fa-spinner fa-spin" aria-hidden="true"></i>'
    : EMAIL_SUBMIT_BTN_HTML;
  emailInput.disabled = isLoading;
}

// Guard flag — prevents multiple simultaneous validate-email requests when the
// user rapidly presses Enter / double-clicks Submit. In-flight submissions
// short-circuit until the current one settles.
let isValidatingEmail = false;

async function validateAndSubmitEmail() {
  if (emailSubmitBtn.getAttribute("aria-disabled") === "true") return;
  if (isValidatingEmail) return; // dedupe rapid-fire clicks / Enter presses

  const email = emailInput.value.trim();
  if (!email) {
    showEmailValidation(
      "Please enter your email address to continue.",
      false
    );
    return;
  }

  if (!EMAIL_FORMAT_REGEX.test(email)) {
    showEmailValidation(
      "Please enter your email address to continue.",
      false
    );
    return;
  }

  isValidatingEmail = true;
  setEmailSubmitLoading(true);

  try {
    const response = await fetch(`${API_BASE_URL}/validate-email`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: email,  // New Code
        session_id: sessionId,  // Include session_id so backend can track the session
        project_name: PROJECT_NAME  // Include project_name for proper room routing
      }),
    });

    const data = await response.json();

    if (data.valid) {
      userEmail = email;
      emailCollected = true;
      showEmailValidation("Email saved successfully!", true);
      // Use project-specific localStorage key
      const existingData = localStorage.getItem(CHAT_USER_DATA_KEY) || "{}";
      localStorage.setItem(
        CHAT_USER_DATA_KEY,
        JSON.stringify({
          ...JSON.parse(existingData),
          email: email,
        })
      );

      hideEmailField();

      // New Code
      setTimeout(() => {
        const emailMessage = `My email is ${email}`;
        addMessage("user", emailMessage);

        // Send to bot via HTTP endpoint — the server's /chat handler already
        // emits customer_message to the dashboard room, so we must NOT also
        // emit via socket or the dashboard would receive it twice (duplicate).
        sendMessageToBot(emailMessage);
      }, 1000); // End
    } else {
      showEmailValidation(data.message, false);
    }
  } catch (error) {
    showEmailValidation("Email validation failed", false);
  } finally {
    // Always exit loading state so the user can retry (e.g., on network error / invalid email)
    isValidatingEmail = false;
    setEmailSubmitLoading(false);
  }
}

function showEmailValidation(message, isValid) {
  const iconClass = isValid ? "fa-circle-check" : "fa-circle-exclamation";
  emailValidation.innerHTML = "";
  const icon = document.createElement("i");
  icon.className = `fas ${iconClass} ai__chatbot-email-validation-icon`;
  icon.setAttribute("aria-hidden", "true");
  const text = document.createElement("span");
  text.textContent = message;
  emailValidation.append(icon, text);
  emailValidation.className = `ai__chatbot-email-validation ${isValid ? "valid" : "invalid"}`;
  emailValidation.setAttribute("role", isValid ? "status" : "alert");

  const wrapper = emailInput.closest(".ai__chatbot-email-input-wrapper");
  if (wrapper) wrapper.classList.toggle("has-error", !isValid);
  emailInput.setAttribute("aria-invalid", isValid ? "false" : "true");
  emailSubmitBtn.setAttribute("aria-disabled", isValid ? "false" : "true");
}

// Letters, digits and . _ % + - before the @ (no leading, trailing or repeated dots),
// then dot-separated domain labels and a 2+ letter TLD.
const EMAIL_FORMAT_REGEX =
  /^[A-Za-z0-9_%+-]+(\.[A-Za-z0-9_%+-]+)*@([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z]{2,}$/;
let emailInputValidationTimeout = null;

function validateEmailOnInput() {
  clearTimeout(emailInputValidationTimeout);
  const email = emailInput.value.trim();

  if (EMAIL_FORMAT_REGEX.test(email)) {
    clearEmailValidation();
    return;
  }

  // Wait for a pause in typing so the error doesn't flash on every keystroke.
  emailInputValidationTimeout = setTimeout(() => {
    showEmailValidation(
      "Please enter your email address to continue.",
      false
    );
  }, 400);
}

function clearEmailValidation() {
  emailValidation.innerHTML = "";
  emailValidation.className = "ai__chatbot-email-validation";
  emailValidation.removeAttribute("role");
  const wrapper = emailInput.closest(".ai__chatbot-email-input-wrapper");
  if (wrapper) wrapper.classList.remove("has-error");
  emailInput.removeAttribute("aria-invalid");
  emailSubmitBtn.removeAttribute("aria-disabled");
}

function hideEmailField() {
  emailFieldContainer.style.display = "none";

  enableChatInput();
}

function showEmailField() {
  emailFieldContainer.style.display = "block";
  emailInput.focus();

  disableChatInput();
}

function disableChatInput() {
  messageInput.disabled = true;
  messageInput.placeholder = "Please enter your email first...";
  sendBtn.disabled = true;
  messageInput.classList.add("disabled");
  sendBtn.classList.add("disabled");
 
  quickActionBtns.forEach((btn) => {
    if(!btn.dataset.action == "get-quote"){
      btn.disabled = true;
      btn.classList.add("disabled");
    }
  });
}
 

function enableChatInput() {
  messageInput.disabled = false;
  messageInput.placeholder = "Type your message here...";
  sendBtn.disabled = false;
  messageInput.classList.remove("disabled");
  sendBtn.classList.remove("disabled");

  quickActionBtns.forEach((btn) => {
    btn.disabled = false;
    btn.classList.remove("disabled");
  });
}

let uploadedLogos = [];

function chatbotHandleLogoFileSelect(event) {
  const files = Array.from(event.target.files);
  handleLogoFiles(files);
}

function chatbotHandleDragOver(event) {
  event.preventDefault();
  logoUploadArea.classList.add("dragover");
}

function chatbotHandleDragLeave(event) {
  event.preventDefault();
  logoUploadArea.classList.remove("dragover");
}

function chatbotHandleDrop(event) {
  event.preventDefault();
  logoUploadArea.classList.remove("dragover");
  const files = Array.from(event.dataTransfer.files);
  handleLogoFiles(files);
}

function handleLogoFiles(files) {
  files.forEach((file) => {
    if (isValidLogoFile(file)) {
      uploadLogoFile(file);
    } else {
      alert(
        `Invalid file: ${file.name}. Please upload JPG, PNG, PDF, AI, or EPS files under 10MB.`
      );
    }
  });
}

function isValidLogoFile(file) {
  const validTypes = [
    "image/jpeg",
    "image/png",
    "application/pdf",
    "application/postscript",
  ];
  const validExtensions = [".jpg", ".jpeg", ".png", ".pdf", ".ai", ".eps"];
  const maxSize = 10 * 1024 * 1024; // 10MB

  const hasValidType = validTypes.includes(file.type);
  const hasValidExtension = validExtensions.some((ext) =>
    file.name.toLowerCase().endsWith(ext)
  );
  const hasValidSize = file.size <= maxSize;

  return (hasValidType || hasValidExtension) && hasValidSize;
}

async function uploadLogoFile(file) {
  const logoId =
    "logo_" + Date.now() + "_" + Math.random().toString(36).substr(2, 9);

  addLogoPreviewItem(logoId, file, "uploading");

  try {
    const formData = new FormData();
    formData.append("logo", file);
    formData.append("session_id", sessionId);

    const response = await fetch(`${API_BASE_URL}/upload-logo`, {
      method: "POST",
      body: formData,
    });

    const data = await response.json();

    if (data.success) {
      updateLogoPreviewItem(logoId, "success", data.dropbox_url);

      uploadedLogos.push({
        id: logoId,
        filename: file.name,
        dropbox_url: data.dropbox_url,
      });

      uploadedLogoURLs = uploadedLogos
        .map((logo) => logo.dropbox_url)
        .join(", ");

      // Use project-specific localStorage key
      const chatUserData = JSON.parse(
        localStorage.getItem(CHAT_USER_DATA_KEY) || "{}"
      );
      chatUserData.uploadedLogoURLs = uploadedLogoURLs;
      chatUserData.uploadedLogos = uploadedLogos;
      localStorage.setItem(CHAT_USER_DATA_KEY, JSON.stringify(chatUserData))
    } else {
      updateLogoPreviewItem(logoId, "error");
    }
  } catch (error) {
    updateLogoPreviewItem(logoId, "error");
  }
}

function addLogoPreviewItem(logoId, file, status) {
  const previewItem = document.createElement("div");
  previewItem.className = "ai__chatbot-logo-preview-item";
  previewItem.id = logoId;

  const isImage = file.type.startsWith("image/");
  const previewContent = isImage
    ? `<img src="${URL.createObjectURL(file)}" alt="${file.name}">`
    : `<i class="fas fa-file" style="font-size: 48px; color: var(--text-light); margin-bottom: 8px;"></i>`;

  previewItem.innerHTML = `
        ${previewContent}
        <div class="ai__chatbot-logo-name">${file.name}</div>
        <div class="ai__chatbot-logo-status ${status}">${status}</div>
        <button class="ai__chatbot-remove-logo" onclick="removeLogo('${logoId}')">
            <i class="fas fa-times"></i>
        </button>
        <div class="ai__chatbot-logo-upload-progress">
            <div class="ai__chatbot-logo-upload-progress-bar" style="width: ${
              status === "uploading" ? "50%" : "100%"
            }"></div>
        </div>
    `;

  logoPreviewList.appendChild(previewItem);
  logoPreviewContainer.style.display = "block";
}

function updateLogoPreviewItem(logoId, status, dropboxUrl = null) {
  const previewItem = document.getElementById(logoId);
  if (previewItem) {
    const statusElement = previewItem.querySelector(".ai__chatbot-logo-status");
    const progressBar = previewItem.querySelector(
      ".ai__chatbot-logo-upload-progress-bar"
    );

    statusElement.className = `logo-status ${status}`;
    statusElement.textContent = status;

    if (status === "success") {
      progressBar.style.width = "100%";
      progressBar.style.background = "var(--success-color)";
    } else if (status === "error") {
      progressBar.style.background = "var(--error-color)";
    }
  }
}

function removeLogo(logoId) {
  const previewItem = document.getElementById(logoId);
  if (previewItem) {
    previewItem.remove();
    uploadedLogos = uploadedLogos.filter((logo) => logo.id !== logoId);

    if (uploadedLogos.length === 0) {
      logoPreviewContainer.style.display = "none";
    }
  }
}

async function showUploadedLogos() {
  try {
    const response = await fetch(`${API_BASE_URL}/session/${sessionId}/logos`);
    const data = await response.json();

    if (data.logos && data.logos.length > 0) {
      const logoList = data.logos
        .map(
          (logo) =>
            `• ${logo.filename} (${logo.dropbox_url || logo.public_url})`
        )
        .join("\n");

      addMessage("ai", `Here are the logos you've uploaded:\n${logoList}`);
    } else {
      addMessage("ai", "You haven't uploaded any logos yet.");
    }
  } catch (error) {
    addMessage("ai", "Sorry, I couldn't retrieve your uploaded logos.");
  }
}

async function sendMessage() {
  const message = messageInput.value.trim();
  if (!message) return;

  if (customerTypingTimeout) {
    clearTimeout(customerTypingTimeout);
    customerTypingTimeout = null;
  }
  if (isCustomerTyping && socket && socket.connected) {
    isCustomerTyping = false;
    socket.emit("customer_typing", {
      session_id: sessionId,
      is_typing: false,
    });
  }

  addMessage("user", message);
  messageInput.value = "";
  autoResizeInput();

  if (agentMode) {
    sendMessageToAgent(message);
    return;
  }

  if (awaitingPhoneNumber) {
    const phoneRegex = /^\+1 \(\d{3}\) \d{3}-\d{4}$/;
    if (!phoneRegex.test(message)) {
      addMessage(
        "ai",
        "❌ Please enter a valid phone number in this format: <br><strong>+1 (537) 874-3292</strong>"
      );
      awaitingPhoneNumber = true; // keep waiting for correct phone
      return;
    }

    awaitingPhoneNumber = false;

    try {
      const response = await fetch(`${API_BASE_URL}/request-call`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ phone: message, session_id: sessionId }),
      });

      if (response.ok) {
        addMessage("ai", "✅ We’re calling you shortly.");
      } else {
        addMessage(
          "ai",
          "❌ Failed to request a call. Please try again later."
        );
      }
    } catch (err) {
      addMessage("ai", "⚠️ Something went wrong while requesting the call.");
    }

    return;
  }

  await sendMessageToBot(message);
}

function sendMessageToAgent(message) {
  if (!socket || socket.disconnected) {
    addMessage(
      "system",
      "Connection to the live agent was interrupted. Please refresh the page or try again."
    );
    return;
  }

  if (!userEmail) {
    showEmailField();
    showEmailValidation(
      "Please enter your email to continue chatting with the live agent.",
      false
    );
    return;
  }

  socket.emit("customer_message", {
    session_id: sessionId,
    email: userEmail,
    message: message,
    project_name: PROJECT_NAME,  // Include project_name in the event New Code
  });
}

async function sendMessageToBot(message) {
  if (agentMode) {
    return;
  }
  addTypingIndicator();
  isTyping = true;

  try {
    const response = await fetch(`${API_BASE_URL}/chat`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        message: message,
        session_id: sessionId,
        email: userEmail,
        project_name: PROJECT_NAME
      }),
    });

    const data = await response.json();

    if (response.ok) {
      if (data.agent_active || data.conversation_flag === "agent") {
        removeTypingIndicator();
        activateAgentMode(false);
        return;
      }

      if (data.message) {
        addMessage("ai", data.message);
      }

      const shouldOpenForm = data.quote_form_triggered ||
        (data.message && /open.*(form|quote)|let me open|form.*(again|open)/i.test(data.message));
      if (shouldOpenForm) {
        setTimeout(() => {
          showQuoteForm();
        }, 1000);
      }

      if (data.message.toLowerCase().includes("email") && !emailCollected) {
        showEmailField();
      }
    } else {
      throw new Error(data.message || "Failed to send message");
    }
  } catch (error) {
    addMessage("ai", "Sorry, I encountered an error. Please try again.");
  } finally {
    isTyping = false;
    focusInput();
  }
}

function showQuoteForm() {
  quoteModal.classList.add("ai__chatbot-modal-show");

  if (sessionId) {
    loadExistingQuoteData();
  } else {
    resetUnitButtons();
  }
}

function closeQuoteForm(resetForm = true) {
  quoteModal.classList.remove("ai__chatbot-modal-show");
  if(typeof resetAndShowForm == "function"){
    resetAndShowForm();
  }
  if (!resetForm) return;

  // quoteForm.reset();
  //uploadedLogos = [];
  //logoPreviewList.innerHTML = "";
 // logoPreviewContainer.style.display = "none";
}

function closeQuoteSummary(resetForm = false) {
  quoteSummaryModal.classList.remove("ai__chatbot-modal-show");
  if (resetForm) closeQuoteForm();
}

function resetUnitButtons() {
  const unitButtons = document.querySelectorAll(".ai__chatbot-unit-btn");
  unitButtons.forEach((btn) => {
    btn.classList.remove("active");
    if (btn.dataset.unit === "inches") {
      btn.classList.add("active");
    }

    const fieldGroup = btn?.closest(".input-with-unit");
    const input = fieldGroup?.querySelector("input");
    if (input) {
      input.dataset.unit = "inches";
    }
  });
}

function clearStoredQuoteData() {}

function startFreshQuote() {
  clearStoredQuoteData();
  resetUnitButtons();
  quoteForm.reset();

  uploadedLogos = [];
  logoPreviewList.innerHTML = "";
  logoPreviewContainer.style.display = "none";
}

async function chatbotHandleQuoteSubmit() {
  if (!userEmail) {
    alert("Please provide your email address first.");
    return;
  }

  const widthInput = document.getElementById("width");
  const heightInput = document.getElementById("height");
  const width = widthInput.value.trim();
  const height = heightInput.value.trim();

  if (width || height) {
    if (!width || !height) {
      alert(
        "Please enter both width and height dimensions, or leave both empty."
      );
      return;
    }

    if (
      isNaN(width) ||
      isNaN(height) ||
      Number.parseFloat(width) <= 0 ||
      Number.parseFloat(height) <= 0
    ) {
      alert("Please enter valid positive numbers for dimensions.");
      return;
    }
  }

  const formData = new FormData(quoteForm);
  const quoteData = {};

  for (const [key, value] of formData.entries()) {
    quoteData[key] = value;
  }

  const widthUnit = widthInput.dataset.unit || "inches";
  const heightUnit = heightInput.dataset.unit || "inches";

  if (width && height) {
    quoteData.sizeDimensions = `${width} ${widthUnit} × ${height} ${heightUnit}`;
    quoteData.width = width;
    quoteData.height = height;
    quoteData.widthUnit = widthUnit;
    quoteData.heightUnit = heightUnit;
  }

  quoteData.uploadedLogos = uploadedLogos;
  quoteData.logoCount = uploadedLogos.length;

  // Use project-specific localStorage key
  const existingData = localStorage.getItem(CHAT_USER_DATA_KEY) || "{}";
  localStorage.setItem(
    CHAT_USER_DATA_KEY,
    JSON.stringify({
      ...JSON.parse(existingData),
      quoteData: quoteData,
    })
  );

  try {
    const response = await fetch(`${API_BASE_URL}/save-quote`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        session_id: sessionId,
        email: userEmail,
        form_data: quoteData,
        project_name: PROJECT_NAME  // Include project_name for proper room routing
      }),
    });

    const data = await response.json();
    saveQuoteToAirtable(userEmail, quoteData)
      .then((result) => {})
      .catch((err) => {});
    if (data.success) {
      closeQuoteForm(false);
      showQuoteSummary(quoteData);

      addMessage(
        "user",
        "I have submitted my quote request with all the details."
      );
      sendMessageToBot(
        "I have submitted my quote request with all the details."
      );
    } else {
      alert("Error saving quote: " + data.error);
    }
  } catch (error) {
    alert("Error submitting quote. Please try again.");
  }
}

async function saveQuoteToAirtable(email, quoteData) {
  const formatArray = (value) =>
    Array.isArray(value) ? value.join(", ") : value || "Not provided";

  const details = `
📏 Dimensions: ${quoteData.sizeDimensions || "Not provided"}
🧱 Material: ${formatArray(quoteData.materialPreference)}
💡 Illumination: ${formatArray(quoteData.illumination)}
🏗️ Installation Surface: ${formatArray(quoteData.installationSurface)}
📍 City & State: ${quoteData.cityState || "Not provided"}
💰 Price: ${quoteData.price || "Not provided"}
📦 Placement: ${formatArray(quoteData.placement)}
⏰ Deadline: ${formatArray(quoteData.deadline)}
📝 Notes: ${quoteData.additionalNotes || "None"}
`;

  try {
    const response = await fetch(
      "https://copy-lead.marke-ter.online/api/quote/submit",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          // "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]').content,
        },
        body: JSON.stringify({
          email,
          details: details.trim(),
          logo_urls: uploadedLogoURLs, // Send comma-separated logo URLs
        }),
      }
    );

    return await response.json();
  } catch (error) {
    console.error("❌ Error saving quote to Airtable:", error);
    return { success: false, error };
  }
}

function showQuoteSummary(quoteData) {
  const logoSection =
    quoteData.uploadedLogos && quoteData.uploadedLogos.length > 0
      ? `
        <div class="quote-summary-item">
            <span class="quote-summary-label">Logo Files:</span>
            <span class="quote-summary-value">${quoteData.uploadedLogos.length} file(s) uploaded</span>
        </div>
    `
      : "";

  const summaryHTML = `
        <div class="quote-summary">
            <h3>Your Quote Request Details</h3>
            ${logoSection}
            <div class="quote-summary-item">
                <span class="quote-summary-label">Size & Dimensions:</span>
                <span class="quote-summary-value">${
                  quoteData.sizeDimensions || "Not specified"
                }</span>
            </div>
            <div class="quote-summary-item">
                <span class="quote-summary-label">Material:</span>
                <span class="quote-summary-value">${
                  quoteData.materialPreference || "Not specified"
                }</span>
            </div>
            <div class="quote-summary-item">
                <span class="quote-summary-label">Illumination:</span>
                <span class="quote-summary-value">${
                  quoteData.illumination || "Not specified"
                }</span>
            </div>
            <div class="quote-summary-item">
                <span class="quote-summary-label">Installation Surface:</span>
                <span class="quote-summary-value">${
                  quoteData.installationSurface || "Not specified"
                }</span>
            </div>
            <div class="quote-summary-item">
                <span class="quote-summary-label">Location:</span>
                <span class="quote-summary-value">${
                  quoteData.cityState || "Not specified"
                }</span>
            </div>
            <div class="quote-summary-item">
                <span class="quote-summary-label">Budget:</span>
                <span class="quote-summary-value">${
                  quoteData.budget || "Not specified"
                }</span>
            </div>
            <div class="quote-summary-item">
                <span class="quote-summary-label">Placement:</span>
                <span class="quote-summary-value">${
                  quoteData.placement || "Not specified"
                }</span>
            </div>
            <div class="quote-summary-item">
                <span class="quote-summary-label">Deadline:</span>
                <span class="quote-summary-value">${
                  quoteData.deadline || "Not specified"
                }</span>
            </div>
            ${
              quoteData.additionalNotes
                ? `
            <div class="quote-summary-item">
                <span class="quote-summary-label">Additional Notes:</span>
                <span class="quote-summary-value">${quoteData.additionalNotes}</span>
            </div>
            `
                : ""
            }
        </div>
        <p><strong>Next Steps:</strong></p>
        ${
          quoteData.uploadedLogos && quoteData.uploadedLogos.length > 0
            ? "<p>✅ Your logo files have been uploaded successfully and are ready for our designers to work with.</p>"
            : '<p>Please email your logo files to <a href="mailto:info@signize.us">info@signize.us</a> so our designers can work with your brand assets.</p>'
        }
        <p>Our team will review your requirements and get back to you with a mockup and quote within a few hours.</p>
    `;

  quoteSummaryContent.innerHTML = summaryHTML;
  quoteSummaryModal.classList.add("ai__chatbot-modal-show");
}

async function loadExistingQuoteData() {
  try {
    console.log("🔄 Starting to load existing quote data...");
    console.log("Session ID:", sessionId);

    const response = await fetch(
      `${API_BASE_URL}/get-quote/${sessionId}`
    );
    console.log("📡 API Response status:", response.status);

    if (response.ok) {
      const data = await response.json();
      console.log("📊 Raw API response data:", data);

      if (data.form_data && Object.keys(data.form_data).length > 0) {
        console.log(
          "📋 Found form data with keys:",
          Object.keys(data.form_data)
        );
        console.log("📋 Form data values:", data.form_data);

        // Wait for form to be fully ready
        await waitForFormReady();

        // Pre-fill the form with existing data
        let filledCount = 0;
        Object.keys(data.form_data).forEach((key) => {
          let element = quoteForm.elements[key];

          // Handle field name variations
          if (!element) {
            // Try alternative field names
            const fieldMappings = {
              width: "width",
              height: "height",
              materialPreference: "materialPreference",
              illumination: "illumination",
              installationSurface: "installationSurface",
              cityState: "cityState",
              budget: "budget",
              placement: "placement",
              deadline: "deadline",
              additionalNotes: "additionalNotes",
            };

            if (fieldMappings[key]) {
              element = quoteForm.elements[fieldMappings[key]];
            }
          }

          if (element) {
            console.log(
              "elment",
              element,
              "key",
              key,
              "data.form_data[key]",
              data.form_data[key]
            );
            if (element.type == "file") return;
            element.value = data.form_data[key];
            const inputEl = document.querySelector(
              `input[name="${key}"][value="${data.form_data[key]}"]`
            );
            console.log("inputEl", inputEl);
            if (inputEl) {
              inputEl.checked = true;
            }
            console.log(
              `✅ Filled field ${key} with value: "${data.form_data[key]}"`
            );
            filledCount++;
          } else {
            console.log(`❌ Field ${key} not found in form`);
          }
        });

        console.log(
          `📝 Filled ${filledCount} out of ${
            Object.keys(data.form_data).length
          } fields`
        );

        // Restore unit buttons if we have unit data
        if (data.form_data.widthUnit || data.form_data.heightUnit) {
          console.log("🔧 Restoring unit buttons from form data:", {
            widthUnit: data.form_data.widthUnit,
            heightUnit: data.form_data.heightUnit,
          });
          restoreUnitButtonsFromData(data.form_data);
        } else {
          console.log("🔧 No unit data found in form data, using defaults");
          resetUnitButtons();
        }

        console.log("✅ Form successfully loaded with existing data");
      } else {
        console.log("⚠️  No form_data found or form_data is empty");
        console.log("Data structure:", data);
        resetUnitButtons();
      }
    } else {
      console.log(
        "❌ API response not OK:",
        response.status,
        response.statusText
      );
    }
  } catch (error) {
    console.error("❌ Error loading existing quote data:", error);
    // resetUnitButtons();
  }
}

function waitForFormReady() {
  return new Promise((resolve) => {
    let attempts = 0;
    const maxAttempts = 50; // 5 seconds max wait

    const checkForm = () => {
      attempts++;
      console.log(`🔄 Checking if form is ready (attempt ${attempts})...`);

      // Check if key form elements exist
      const widthField = quoteForm.elements["width"];
      const materialField = quoteForm.elements["materialPreference"];

      if (widthField && materialField) {
        console.log("✅ Form is ready, proceeding with data loading");
        resolve();
      } else if (attempts >= maxAttempts) {
        console.log(
          "⚠️  Form not ready after maximum attempts, proceeding anyway"
        );
        resolve();
      } else {
        console.log("⏳ Form not ready yet, waiting...");
        setTimeout(checkForm, 100);
      }
    };

    checkForm();
  });
}

function restoreUnitButtonsFromData(formData) {
  try {
    console.log("Restoring unit buttons from data:", formData);

    if (formData.widthUnit) {
      // Restore width unit
      const widthButtons = document.querySelectorAll(
        '[data-field="width"].ai__chatbot-unit-btn'
      );
      console.log(`Found ${widthButtons.length} width unit buttons`);

      widthButtons.forEach((btn) => {
        btn.classList.remove("active");
        if (btn.dataset.unit === formData.widthUnit) {
          btn.classList.add("active");
          console.log(`Activated width button: ${formData.widthUnit}`);
        }
      });

      // Update input dataset unit
      const widthInput = document.getElementById("width");
      if (widthInput) {
        widthInput.dataset.unit = formData.widthUnit;
        console.log(`Set width input unit to: ${formData.widthUnit}`);
      }
    }

    if (formData.heightUnit) {
      // Restore height unit
      const heightButtons = document.querySelectorAll(
        '[data-field="height"].ai__chatbot-unit-btn'
      );
      console.log(`Found ${heightButtons.length} height unit buttons`);

      heightButtons.forEach((btn) => {
        btn.classList.remove("active");
        if (btn.dataset.unit === formData.heightUnit) {
          btn.classList.add("active");
          console.log(`Activated height button: ${formData.heightUnit}`);
        }
      });

      // Update input dataset unit
      const heightInput = document.getElementById("height");
      if (heightInput) {
        heightInput.dataset.unit = formData.heightUnit;
        console.log(`Set height input unit to: ${formData.heightUnit}`);
      }
    }

    console.log(
      `Successfully restored units: Width=${formData.widthUnit}, Height=${formData.heightUnit}`
    );
  } catch (error) {
    console.error("Error restoring unit buttons from form data:", error);
    // Fall back to default if there's an error
    resetUnitButtons();
  }
}

function requestQuoteChanges() {
  closeQuoteSummary();
  showQuoteForm();
}

function showAgentTypingIndicator(show) {
  if (!chatMessages) {
    return;
  }

  let typingIndicator = document.getElementById("agent-typing-indicator");

  if (show) {
    if (!typingIndicator) {
      typingIndicator = document.createElement("div");
      typingIndicator.id = "agent-typing-indicator";
      typingIndicator.className = "message agent-message typing-indicator";
      typingIndicator.innerHTML = `
        <div class="message-avatar">
          <i class="fas fa-headset"></i>
        </div>
        <div class="message-content">
          <div class="message-bubble">
            <div class="typing-dots">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
          <div class="message-time">Agent is typing...</div>
        </div>
      `;
      chatMessages.appendChild(typingIndicator);
    } else {
      chatMessages.appendChild(typingIndicator);
    }
    typingIndicator.style.display = "flex";
    scrollToBottom();
  } else {
    if (typingIndicator) {
      typingIndicator.style.display = "none";
    }
  }
}

// Add message to chat
function addMessage(sender, content, options = {}) {
  removeTypingIndicator();

  if (
    sender === "ai" ||
    sender === "agent" ||
    sender === "bot" ||
    sender === "system"
  ) {
    // Remove both AI typical typing indicator and agent specific typing indicator
    removeTypingIndicator();
    showAgentTypingIndicator(false);
  }

  const messageDiv = document.createElement("div");
  messageDiv.className = `message ${sender}-message slide-up`;

  const currentTime = options?.created_at ? toChatTime(options.created_at) : toChatTime();

  let avatarContent = `<i class="fas fa-user"></i>`;
  if (sender === "ai") {
    avatarContent = `<img src="https://quicksignage.com/cdn/shop/files/quicksignage-white-green-transparent_220x.png?v=1720830496" alt="AI Assistant" class="robot-avatar">`;
  } else if (sender === "agent") {
    avatarContent = `<i class="fas fa-headset"></i>`;
  } else if (sender === "system") {
    avatarContent = `<i class="fas fa-info-circle"></i>`;
  }

  let timeLabel = currentTime;
  if (sender === "agent") {
    const agentName = options.agentName || "Live Agent";
    timeLabel = `${agentName} • ${currentTime}`;
  }

  messageDiv.innerHTML = `
        <div class="message-avatar">
            ${avatarContent}
        </div>
        <div class="message-content">
            <div class="message-bubble">
                <p>${formatMessage(content)}</p>
            </div>
            <div class="message-time">${timeLabel}</div>
        </div>
    `;

  const typingIndicator = document.getElementById("agent-typing-indicator");
  if (typingIndicator && typingIndicator.parentNode === chatMessages) {
    chatMessages.insertBefore(messageDiv, typingIndicator);
  } else {
    chatMessages.appendChild(messageDiv);
  }
  scrollToBottom();
}

// Format message content (handle links, code blocks, etc.)
function formatMessage(content) {
  // Convert URLs to clickable links
  content = content.replace(
    /(https?:\/\/[^\s]+)/g,
    '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>'
  );

  // Convert line breaks to <br> tags
  content = content.replace(/\n/g, "<br>");

  return content;
}

// Add typing indicator
function addTypingIndicator() {
  const typingDiv = document.createElement("div");
  typingDiv.className = "message ai-message typing-indicator";
  typingDiv.id = "typing-indicator";

  typingDiv.innerHTML = `
        <div class="message-avatar">
            <img src="https://quicksignage.com/cdn/shop/files/quicksignage-white-green-transparent_220x.png?v=1720830496" alt="AI Assistant" class="robot-avatar">
        </div>
        <div class="message-content">
            <div class="message-bubble">
              <div class="typing-dots">
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>
        </div>
    `;

  if (document.getElementById("typing-indicator")) return;
  chatMessages.appendChild(typingDiv);
  scrollToBottom();
}

// Remove typing indicator
function removeTypingIndicator() {
  const typingIndicator = document.getElementById("typing-indicator");
  if (typingIndicator) {
    typingIndicator.remove();
  }
}

// Handle quick actions
function handleQuickAction(action) {
  let message = "";

  switch (action) {
    case "start-design":
      message =
        "I'd like to start designing a custom sign. Can you help me with the process?";
      break;
    case "get-quote":
      message = "I want a mockup and quote for a custom sign.";
      break;
    case "view-portfolio":
      message =
        "Can you show me some examples of your previous work or portfolio?";
      break;
    case "instant-call":
      addMessage(
        "ai",
        `
        Don’t have time to wait? Please enter your <strong>phone number</strong> and we’ll call you shortly.
      `
      );
      awaitingPhoneNumber = true;
      return; // prevent normal send flow
    default:
      return;
  }

  // Set the message in input and send it
  messageInput.value = message;
  sendMessage();
}

// Scroll to bottom of chat
function scrollToBottom() {
  chatMessages.scrollTop = chatMessages.scrollHeight;
}

// Focus on input
function focusInput() {
  messageInput.focus();
}

// Auto-resize input
function autoResizeInput() {
  messageInput.style.height = "auto";
  messageInput.style.height = Math.min(messageInput.scrollHeight, 120) + "px";
}

// Minimize chat
function minimizeChat() {
  const chatContainer = document.querySelector(".ai__chatbot-chat-container");
  chatContainer.classList.toggle("minimized");

  if (chatContainer.classList.contains("minimized")) {
    minimizeBtn.innerHTML = '<i class="fas fa-expand"></i>';
  } else {
    minimizeBtn.innerHTML = '<i class="fas fa-minus"></i>';
  }
}

// Close chat
function closeChat() {
  const chatContainer = document.querySelector(".ai__chatbot-chat-container");
  chatContainer.classList.add("ai__chatbot-hidden");
  document.body.classList.remove("chatbot-open");
  // Show FAB
  fabBtn.style.display = "flex";
  chatCloseBtn.style.display = "none";
  // setMainIcon() is defined in floating-chatbot.liquid
  if (typeof setMainIcon == "function") setMainIcon(false);
}
function openChat() {
  const chatContainer = document.querySelector(".ai__chatbot-chat-container");
  chatContainer.classList.remove("ai__chatbot-hidden");
  document.body.classList.add("chatbot-open");
  // Show FAB
  fabBtn.style.display = "none";
  chatCloseBtn.style.display = "flex";
}

// Toggle chat visibility
function toggleChat() {
  const chatContainer = document.querySelector(".ai__chatbot-chat-container");
  chatContainer.classList.remove("ai__chatbot-hidden");
  chatContainer.classList.remove("minimized");
  document.body.classList.add("chatbot-open");

  // Hide FAB
  fabBtn.style.display = "none";
  chatCloseBtn.style.display = "flex";

  // Focus on input
  focusInput();
}

// Utility function to debounce
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

// Add CSS for typing indicator
const typingStyles = `
    /* Hide the WhatsApp widget while the chatbot is open — body.chatbot-open is
       toggled by openChat/toggleChat/closeChat in this file. */
    body.chatbot-open .whatsapp-widget,
    body.chatbot-open #chat-bubble {
        display: none !important;
    }

    .typing-indicator .message-bubble {
        background: var(--bg-tertiary);
        border: 1px solid var(--border-color);
    }
    
    .typing-dots {
        display: flex;
        gap: 4px;
        align-items: center;
        padding: 8px 0;
    }
    
.typing-dots span {
    width: 6px;
    height: 6px;
    background: gray !important;
    border-radius: 50%;
    animation: bounce 1.4s infinite ease-in-out !important;
}
.typing-dots span:nth-child(1) { animation-delay: -0.32s !important; }
.typing-dots span:nth-child(2) { animation-delay: -0.16s !important; }
@keyframes bounce { 0%, 80%, 100% { transform: scale(0); } 40% { transform: scale(1); } }
    
    .chat-container.minimized {
        position: fixed;
        bottom: 0;
        right: 0;
        width: 400px;
        transform: none;
        z-index: 1000;
    }
    
    .chat-container.minimized .chat-messages,
    .chat-container.minimized .chat-input-container {
        display: none;
    }
    
    .chat-container.minimized .chat-header {
        border-radius: var(--border-radius-lg);
    }
    
    @media (max-width: 768px) {
        .chat-container.minimized {
            width: 100%;
            right: 0;
        }
    }
    
    .input-wrapper.focused {
        box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
    }
    
    .message a {
        color: var(--primary-color);
        text-decoration: none;
        font-weight: 500;
    }
    
    .message a:hover {
        text-decoration: underline;
    }
    
    .user-message .message a {
        color: white;
        text-decoration: underline;
    }
`;

// Inject typing styles
const styleSheet = document.createElement("style");
styleSheet.textContent = typingStyles;
document.head.appendChild(styleSheet);

// Export functions for potential external use
window.SignNizeChat = {
  sendMessage,
  sendMessageToBot,
  addMessage,
  handleQuickAction,
  toggleChat,
  minimizeChat,
  closeChat,
  closeQuoteForm,
};

function testUnitButtons() {
  console.log("Testing unit button functionality...");

  // Check if unit buttons exist
  const widthButtons = document.querySelectorAll(
    '[data-field="width"].ai__chatbot-unit-btn'
  );
  const heightButtons = document.querySelectorAll(
    '[data-field="height"].ai__chatbot-unit-btn'
  );

  console.log(
    `Found ${widthButtons.length} width buttons and ${heightButtons.length} height buttons`
  );

  // Check current active states
  widthButtons.forEach((btn) => {
    console.log(
      `Width button ${btn.dataset.unit}: ${
        btn.classList.contains("active") ? "active" : "inactive"
      }`
    );
  });

  heightButtons.forEach((btn) => {
    console.log(
      `Height button ${btn.dataset.unit}: ${
        btn.classList.contains("active") ? "active" : "inactive"
      }`
    );
  });

  // Check input dataset units
  const widthInput = document.getElementById("width");
  const heightInput = document.getElementById("height");

  console.log("Input dataset units:", {
    width: widthInput?.dataset.unit || "not set",
    height: heightInput?.dataset.unit || "not set",
  });
}

// Load chat history for existing session
async function loadChatHistory() {
  let restoreEmailPrompt = false;
  try {
    // console.log("🔄 Loading chat history for session:", sessionId);

    const response = await fetch(
      `${API_BASE_URL}/session/${sessionId}/messages`
    );
    const data = await response.json();

    if (data.success && data.messages && data.messages.length > 0) {
      // console.log(
      //   "📚 Found existing chat history:",
      //   data.messages.length,
      //   "messages"
      // );

      // Clear any existing messages
      chatMessages.innerHTML = "";

      // Load each message
      data.messages.forEach((message) => {
        if (message.role === "user") {
          addMessage("user", message.content, {created_at: message?.created_at});
        } else if (message.role === "bot") {
          addMessage("ai", message.content, {created_at: message?.created_at});
        } else if (message.role === "agent") {
          addMessage("agent", message.content, {
            agentName: "Signmakers.net" || message.agent_name || "Live Agent",
            created_at: message?.created_at
          });
        }
      });

      // A placeholder address (see generate_dummy_email in app.py) is not a
      // real email — don't treat it as collected, or the bot never asks again.
      if (data.email && !data.email.toLowerCase().endsWith("@anonymous.com")) {
        userEmail = data.email;
        emailCollected = true;
      }

      // if (data.conversation_flag === "agent") {
      //   activateAgentMode(false);
      // }

      // If the bot asked for the email before the refresh and the visitor never
      // gave one, ask again instead of silently reopening the chat. Live-agent
      // conversations are left alone — email is optional there.
      const botAskedForEmail = data.messages.some(
        (m) => m.role === "bot" && (m.content || "").toLowerCase().includes("email")
      );
      if (!emailCollected && !agentMode && botAskedForEmail) {
        restoreEmailPrompt = true;
      }

      chatMessages.scrollTop = chatMessages.scrollHeight;
    }
  } catch (error) {}
  if (restoreEmailPrompt) {
    showEmailField();
    showEmailValidation(
      "Please enter your email address to continue.",
      false
    );
  }
}

function testLoadQuoteData() {
  console.log("🧪 Testing quote data loading...");
  console.log("Session ID:", sessionId);

  // Test the API endpoint directly
  fetch(`${API_BASE_URL}/get-quote/${sessionId}`)
    .then((response) => response.json())
    .then((data) => {
      console.log("📊 Raw API response:", data);

      if (data.form_data) {
        console.log("📋 Form data keys:", Object.keys(data.form_data));
        console.log("📋 Form data values:", data.form_data);

        // Check if we can fill the form
        Object.keys(data.form_data).forEach((key) => {
          const element = quoteForm.elements[key];
          if (element) {
            console.log(`✅ Can fill ${key}: ${element.type}`);
          } else {
            console.log(`❌ Cannot fill ${key}: field not found`);
          }
        });
      } else {
        console.log("⚠️  No form_data in response");
      }
    })
    .catch((error) => {
      console.error("❌ Error testing quote data:", error);
    });
}

function testDatabaseConnection() {
  console.log("🧪 Testing database connection...");

  // Test the MongoDB status endpoint
  fetch(`${API_BASE_URL}/mongodb-status`)
    .then((response) => response.json())
    .then((data) => {
      console.log("📊 MongoDB Status:", data);
    })
    .catch((error) => {
      console.error("❌ Error checking MongoDB status:", error);
    });

  // Test the test-mongodb endpoint
  fetch(`${API_BASE_URL}/test-mongodb`)
    .then((response) => response.json())
    .then((data) => {
      console.log("📊 MongoDB Connection Test:", data);
    })
    .catch((error) => {
      console.error("❌ Error testing MongoDB connection:", error);
    });
}

function testQuoteDataStorage() {
  console.log("🧪 Testing quote data storage...");

  // Test saving some data
  const testData = {
    session_id: sessionId,
    email: "test@example.com",
    form_data: {
      width: "24",
      height: "36",
      widthUnit: "inches",
      heightUnit: "inches",
      materialPreference: "metal",
      illumination: "led-backlit",
      installationSurface: "brick-wall",
      cityState: "New York, NY",
      budget: "1000-2500",
      placement: "outdoor",
      deadline: "standard",
      additionalNotes: "Test data for debugging",
    },
  };

  fetch(`${API_BASE_URL}/save-quote`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(testData),
  })
    .then((response) => response.json())
    .then((data) => {
      console.log("📊 Save Quote Response:", data);

      if (data.success) {
        console.log(
          "✅ Test data saved successfully, now testing retrieval..."
        );
        // Test retrieving the data
        setTimeout(() => {
          testLoadQuoteData();
        }, 1000);
      }
    })
    .catch((error) => {
      console.error("❌ Error saving test data:", error);
    });
}

// convert 2026-01-16T04:16:32.933912Z to → 4:16 AM
function toChatTime(isoString) {
  const date = isoString ? new Date(isoString) : new Date();

  return date.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true
  });
}

// Add to global scope for testing
window.testLoadQuoteData = testLoadQuoteData;
window.testDatabaseConnection = testDatabaseConnection;
window.testQuoteDataStorage = testQuoteDataStorage;
